import { useWeb3React } from "@web3-react/core";
import React, { useEffect, useState } from "react";
import useCollapse from "react-collapsed";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import StakePopUp from "./stakePopUp";

export const Section = (props) => {
    const [isOpen, setIsOpen] = useState(false)
    const onOpen = (e) => {
        setIsOpen(true)
    };
    const onClose = (e) => {
        setIsOpen(false)
    };
    // Wallet Connection
    const {
        account,
        active
    } = useWeb3React();

    const config = {
        defaultExpanded: props.defaultExpanded || false,
        collapsedHeight: props.collapsedHeight || 0,
    };
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse(config);
    return (
        <>
            <div className="sn_sn sn_loop collapsible">
                <div className="top_box clearfix header">
                    <div class="sm_img recc">
                        <img src="./logo192.png" class="img-responsive" />
                    </div>
                    {/* <div className="width_hand">
                        <div className="logo"><img src="./logo192.png" alt="" className="img-responsive" /></div>
                        <div className="logo_name">
                            <h4 className="t_upper">EARN <span className="t_orenge">The Grays</span></h4>
                            <p>Stake The Grays</p>
                        </div>
                    </div> */}
                    <div className="width_hand">
                        <h6 className="grey_t">EARN TGC</h6>
                        <p className="grey_t">STAKE TGC</p>
                    </div>
                    <div className="width_hand">
                        <p className="grey_t ">Total Staked</p>
                        <p>{(props.totalStaked).toLocaleString()} TGC </p>
                    </div>
                    {/* <div className="width_hand">
                        <p className="grey_t">Start Time</p>
                        <p>00:00:00</p>
                    </div> */}
                    <div className="width_hand">
                        <p className="grey_t">Last Staking Time</p>
                        <p>{props.lastStartTime}</p>
                    </div>
                    <div className="width_hand">
                        {active ?
                            <button className="orenge_btn" onClick={onOpen}>Stake TGC</button>
                            :
                            <button className="orenge_btn" onClick={props.connectWallet}>Connect</button>
                        }
                        <button className="last_btn mx-2" {...getToggleProps()}>
                            {isExpanded ? <> Show <BiChevronUp /></> : <> Hide <BiChevronDown /></>}
                        </button>
                    </div>
                </div>
                <div {...getCollapseProps()}>
                    <div className="bottom_box content">
                        {props.children}
                    </div>
                </div>
            </div>
            <StakePopUp isOpen={isOpen} closeModal={onClose} updatePage={props.updatePage} minStaking={props.minStaking} totalStaked={props.totalStaked} />
        </>
    );
}